module.exports = __webpack_public_path__ + "media/graphic2/proxy-background-0b008f1a.svg";